export default __webpack_public_path__ + "static/media/gitIcon.140fa4d6.png";